module.exports = __webpack_public_path__ + "img/Banner_football.c384aa35.jpg";